import * as React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {useState} from "react";

interface SiteColumnProps {
  selectedUserId: number | null;
  selectedSiteId: number | null;
  siteIds: number[] | undefined | null;
  getSiteName: (siteId: number) => string;
  onSiteClick: (siteId: number) => void;
}

const SiteColumn: React.FC<SiteColumnProps> = ({
  selectedUserId,
  selectedSiteId,
  siteIds,
  getSiteName,
  onSiteClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedSite, setSelectedSite] = useState<number | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, selectedSiteId: number) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedSite(selectedSiteId);
  };


  return (
    <Grid size={{ xs: 3 }} sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
      {!selectedUserId ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont
          }}
        >
          {t('users:t.selectUser')}
        </Box>
      ) : (
        siteIds?.map((siteId) => (
          <Box
            key={siteId}
            onClick={() => onSiteClick(siteId)}
            sx={{
              display: 'flex',
              height: '30px',
              minHeight: '30px',
              paddingLeft: '12px',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch',
              mb: 1,
              ...theme.typography.usersFontTitle,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
              backgroundColor: selectedSiteId === siteId ? theme.palette.selectedBackground : 'transparent',
              borderRadius: '4px',
            }}
          >
            <Box
              component="span"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flexGrow: 1,
              }}
            >
              {getSiteName(siteId)}
            </Box>
            {selectedSiteId === siteId && (
                <IconButton
                    size="small"
                    onClick={(e) => handleMenuOpen(e, siteId)}
                    sx={{ color: 'green' }}
                >
                  <MoreVertIcon />
                </IconButton>
            )}
          </Box>
        ))
      )}
    </Grid>
  );
};

export default SiteColumn;
